import React, { useState, useEffect } from "react";

export const svg = `<svg width="32" height="24" viewbox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.334 4.923H11.67v14.15h8.664V4.923Z" fill="#FF5F00"></path><path d="M12.562 12A8.983 8.983 0 0 1 16 4.924a8.998 8.998 0 1 0 0 14.151 8.984 8.984 0 0 1-3.437-7.077Z" fill="#EB001B"></path><path d="M29.7 17.575v-.29h.125v-.06h-.297v.06h.117v.29h.055Zm.578 0v-.35h-.09l-.105.25-.105-.25h-.09v.35h.064v-.265l.098.228h.067l.098-.228v.265h.063Zm.282-5.574A8.999 8.999 0 0 1 16 19.075a9 9 0 0 0 0-14.15 8.999 8.999 0 0 1 14.56 7.074V12Z" fill="#F79E1B"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
